import React, { useState } from 'react';
import { cn } from '../lib/utils';

export const Flashcard = ({ front, back, testId }) => {
  const [flipped, setFlipped] = useState(false);

  return (
    <button
      type="button"
      onClick={() => setFlipped(f => !f)}
      data-testid={testId || 'flashcard'}
      className={cn(
        'mc-card w-full min-h-[140px] p-5 flex flex-col items-center justify-center text-center',
        'transition-[transform,box-shadow] duration-200 hover:-translate-y-0.5 hover:shadow-lg',
        'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2'
      )}
      style={{ background: 'linear-gradient(180deg, hsl(var(--card)), hsl(var(--panel)))' }}
    >
      <div className="font-bold text-base leading-snug">
        {flipped ? back : front}
      </div>
      <div className="mt-2 text-xs text-muted-foreground">
        {flipped ? 'Touche pour revenir' : 'Touche pour retourner'}
      </div>
    </button>
  );
};
